export const VITE_APPLICATION_VERSION = import.meta.env
  .VITE_APPLICATION_VERSION;
export const VITE_BUILD_NUMBER = import.meta.env.VITE_BUILD_NUMBER;
/** Build environment (dev/test/staging/prod) — the only version the .env files actually define. */
export const VITE_VERSION = import.meta.env.VITE_VERSION;
